<div class="footer__legals">
  <input class="footer__legals__open__subMenu" type="checkbox" id="privacyPolicy" hidden name="label" />
  <label for="privacyPolicy" class="footer__legalsTitle" i18n="@@FOOTER.LEGAL_INFORMATIONS">
    Privacy Policy
  </label>
  <div class="footer__legalsList footer__legals__subMenu">
    <ng-container *ngTemplateOutlet="accessibilityStatement"></ng-container>
    <ng-container *ngTemplateOutlet="legalLink"></ng-container>
  </div>
</div>

<!-- ACCESSIBILITY STATEMENT TEMPLATE --->
<ng-template #accessibilityStatement>
  <vc-ref
    *ngIf="showAccessibilityLink"
    [resource]="accessibilityStatementLink"
    anchor="true"
    class="footer__legalsLink footer__legalsLink--accessibility"
    i18n="@@FOOTER.LEGALS.ACCESSIBILITY_STATEMENT"
  >
    accessibility statement
  </vc-ref>
</ng-template>

<!-- LEGAL LINK TEMPLATE --->
<ng-template #legalLink>
  <ng-container *ngFor="let legal of legals">
    <vc-ref
      *ngIf="isDisplayed(legal) && legal.name !== '$HIDE$'"
      [resource]="legal.link"
      [anchor]="isAnchor(legal)"
      class="footer__legalsLink"
      [blank]="legal.target === '__blank'"
    >
      {{ legal.name }}
    </vc-ref>
  </ng-container>
</ng-template>
